module.exports = __webpack_public_path__ + "static/media/satvik.ce6e85ba.jpg";